import Vue from "vue";
import VueRouter from "vue-router";

import Login from "@/views/Auth/login.vue";
import ForgotPassword from "@/views/Auth/forgot-password.vue";
import Register from "@/views/Auth/register.vue";

import MainScreen from "@/views/MainScreen/index.vue";
import History from "@/views/History/index.vue";
import HistoryDetail from "@/views/History/detail.vue";
import Panduan from "@/views/Panduan/index.vue";

Vue.use(VueRouter);

function requireAuth(to, from, next) {
  if (localStorage.getItem("token")) {
    next();
  } else {
    next("/login");
  }
}

function requireGuest(to, from, next) {
  if (localStorage.getItem("token")) {
    next("/");
  } else {
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "MainScreen",
    component: MainScreen,
  },
  {
    path: "/panduan",
    name: "Panduan",
    component: Panduan,
  },
  {
    path: "/history",
    name: "History",
    component: History,
    beforeEnter: requireAuth,
  },
  {
    path: "/history/:id",
    name: "HistoryDetail",
    component: HistoryDetail,
    beforeEnter: requireAuth,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: requireGuest,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    beforeEnter: requireGuest,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    beforeEnter: requireGuest,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
